import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import { fromJS } from 'immutable';
import getClassicLink from './get-classic-link';
import getMenuSection from './get-menu-section';
import MastheadBarButtonRecord from '../../../../../records/MastheadBarButtonRecord';
import mapMenuItemSections from './map-menu-item-sections';
import mapBarSectionLinks from './map-bar-section-links';
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
export default function getProfileBarItems(containerSections) {
  return containerSections.reduce(function (barItems, barSections) {
    if (!barSections) {
      return barItems;
    } //   // Iterating over 1st level SECTIONS


    var hasBarLinks = Array.isArray(barSections.links);

    if (!hasBarLinks && barSections.sections) {
      // 2nd Level SECTIONS (profile menu)
      var profileMenuSections = barSections.sections.reduce(function (profileMenuItems, menuItem) {
        var hasMenuLink = Array.isArray(menuItem.links);
        var hasSubMenu = Array.isArray(menuItem.sections);
        var topItems;

        if (hasSubMenu) {
          // 3rd Level SECTIONS (profile subMenu accordions)
          var profileSubMenu = mapMenuItemSections(menuItem.sections);
          topItems = getMenuSection(menuItem, fromJS(profileSubMenu));
          profileMenuItems.push(new MastheadBarButtonRecord(topItems));
        } else if (hasMenuLink) {
          // 2nd Level LINKS (profile links)
          topItems = menuItem.links.map(function (menuLink) {
            return new NavigationItemRecord(getClassicLink(menuLink));
          });
          return profileMenuItems.concat(topItems);
        }

        return profileMenuItems;
      }, []);
      var topSection = getMenuSection(barSections, profileMenuSections);

      if (topSection) {
        barItems.push(new MastheadBarButtonRecord(topSection));
      }

      return barItems;
    } else if (hasBarLinks) {
      // 1st Level LINKS (profile bar)
      return barItems.concat(mapBarSectionLinks(barSections.links));
    }

    return barItems;
  }, []);
}